import React from 'react';

/**
 * ModalHeader - Componente de encabezado para el modal del formulario
 *
 * Props:
 * - title: Título principal del step
 * - subtitle: Subtítulo descriptivo del step (opcional)
 * - currentStep: Número del step actual (para mostrar al usuario)
 * - className: Clases CSS adicionales (opcional)
 */
function ModalHeader({
  title,
  subtitle,
  currentStep,
  className = ''
}) {
  return (
    <div className={`text-center ${className}`}>
      <h2 className="h3 fw-semibold mb-3">
        {title}
      </h2>
      {subtitle && (
        <div className="d-flex align-items-center gap-2 text-start">
          <span className="text-muted">
            {currentStep}.
          </span>
          <p className="text-muted mb-0">
            {subtitle}
          </p>
        </div>
      )}
    </div>
  );
}

export default ModalHeader;
